import React from 'react';
import clsx from 'clsx';
import { MAPPING, MODULE_NAME } from '../helpers';
import { generateImage, trackingEvent } from '../../../../utils';
import { CLICK_EVENT_ACTION_TYPE, CLICK_EVENT_TRIGGER, CTA_ACTION_CATEGORY } from '../../../../constants';

const { labels } = MAPPING;

const OfferCard = ({ offerDetail, index }) => {
  const offerName = Array.isArray(offerDetail.OfferNames) && offerDetail.OfferNames.length > 0 ? offerDetail.OfferNames[0] : '';
  const alt = offerDetail.title || offerName;
  const viewText = `${labels.view} ${offerDetail.numberOffers > 1 ? offerDetail.numberOffers : ''} ${labels.offer}${offerDetail.numberOffers > 1 ? 's' : ''}`;

  const handleTrackingEvent = () => {
    trackingEvent({
      event: CLICK_EVENT_TRIGGER,
      type: CLICK_EVENT_ACTION_TYPE,
      label: `${window.pageName}:${MODULE_NAME}:${viewText}`,
      category: CTA_ACTION_CATEGORY,
      custom: {
        offer: {
          // eslint-disable-next-line camelcase
          offer_name: offerName,
        },
        // eslint-disable-next-line camelcase
        link_metadata: {
          // eslint-disable-next-line camelcase
          destination_url: '',
        },
        metadata: {
          // eslint-disable-next-line camelcase
          target_url: offerDetail.url,
        },
      },
    });
  };

  return (
    <div className={clsx('overflow-hidden rounded-4 flex flex-col w-full h-full justify-between', offerDetail.color, `anima-bottom delay-ins-${index > 4 ? 6 : index + 2}`)}>
      <div className="offers-heading w-full px-12 pt-16 pb-4 lg:px-24">
        {offerName &&
          <h2 className="h5 mb-8">{offerName}</h2>
        }
        <a href={offerDetail.url} className="btn btn-text btn-text-black btn-ani m-0 view-offer-btn"
          onClick={handleTrackingEvent}
        >
          <span>{viewText}</span>
          <span className="sr-only">{`${offerName} ${offerDetail.modelYear} msrp ${offerDetail.msrp}`}</span>
          <span className="relative overflow-hidden inline-flex" aria-hidden>
            <span className="icomoon icon-arrow-right-animation" />
            <span className="icomoon icon-arrow-right-animation absolute -left-11" />
          </span>
        </a>
      </div>
      <div className="w-full pb-12">
        <div className="offer-thumbnail w-full relative px-12 pb-[64.7%]">
          {offerDetail.imageUrl &&
            <img src={generateImage(offerDetail.imageUrl)} className="absolute inset-0 w-full h-full object-scale-down object-center" alt={alt} loading="lazy" />
          }
        </div>
      </div>
    </div>
  );
};

export default OfferCard;